import { render, staticRenderFns } from "./Drugname.vue?vue&type=template&id=e6a262e0&scoped=true&"
import script from "./Drugname.vue?vue&type=script&lang=ts&"
export * from "./Drugname.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a262e0",
  null
  
)

export default component.exports